import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumnCenter } from "../../../../../../Common/Styles";
import { Icons } from "../../../../../../icons";

const EmptyDraft = ({ title }: { title: string }) => {
  const { typography, Color } = useTheme();
  return (
    <EmptyDraftContainer>
      <Icons.EmptyDraftSvg />
      <FlexColumnCenter>
        <Components.Text
          style={{ tokenStyle: typography.Heading.S }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-400"
          text={title}
        />
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          lineHeight="line-height-100"
          text={"Dust off the cobwebs and start writing!."}
          color={Color.text["text-secondary"].value}
        />
      </FlexColumnCenter>
    </EmptyDraftContainer>
  );
};

export default EmptyDraft;

const EmptyDraftContainer = styled(FlexColumnCenter)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
